import { AvailableColour, NCNode } from '../../../../src/commonTypes';
import { isLongNodeLabel } from '../../../../src/graphNodeShape';
import { showAlert } from '../ui/uiUtils';
import { NCNodeDefinition } from '../../types';
import { generateNodeId } from './graphNodeUtils';
import { nodeUserLikeKey } from './nodeLikes';

export const isSameNode = (node1: NCNode | undefined, node2: NCNode | undefined) => {
	if (!node1 || !node2) {
		return false;
	}
	return node1?.uid === node2?.uid;
};

export const addToNodeList = (node: NCNode, nodesList: Array<NCNode>, textNodesOnly = true) => {
	if (textNodesOnly && !node.label) {
		showAlert('Please choose a node containing a label');
		return false;
	}

	const nodeIndex = nodesList.findIndex((n) => n.uid === node.uid);
	if (nodeIndex !== -1) {
		// Remove the node
		nodesList.splice(nodeIndex, 1);
	} else {
		// Add the node
		nodesList.push(node);
	}

	return nodesList;
};

export const constructNodeFromDefinition = (
	nodeDefinition: NCNodeDefinition,
	userColourClass: AvailableColour,
	userId?: string
): NCNode => {
	const newNode: NCNode = {
		uid: generateNodeId(),
		created: new Date().getTime(),
		x: nodeDefinition.x,
		y: nodeDefinition.y,
		colour: userColourClass,
		likes: {},
	};
	const hasImageSource = Boolean(nodeDefinition.src) && !nodeDefinition.isVideo;
	if (nodeDefinition.label) {
		newNode.label = nodeDefinition.label;
		if (!hasImageSource && !nodeDefinition.isVideo && isLongNodeLabel(nodeDefinition.label)) {
			newNode.style = 'rect';
		}
	}
	if (nodeDefinition.isVideo) {
		newNode.isVideo = true;
	}
	if (nodeDefinition.nodeColour) {
		newNode.nodeColour = nodeDefinition.nodeColour;
	}
	if (nodeDefinition.src) {
		newNode.src = nodeDefinition.src;
	}
	if (nodeDefinition.href) {
		newNode.href = nodeDefinition.href;
	}
	if (nodeDefinition.like) {
		newNode.likes = { [userId ? nodeUserLikeKey(userId) : userColourClass]: true };
	}
	if (nodeDefinition.likes && Object.keys(nodeDefinition.likes).length > 0) {
		newNode.likes = { ...nodeDefinition.likes };
		if (nodeDefinition.like && userId) {
			newNode.likes[nodeUserLikeKey(userId)] = true;
		} else if (nodeDefinition.like) {
			newNode.likes[userColourClass] = true;
		}
	}
	if (nodeDefinition.dotted) {
		newNode.dotted = true;
	}
	if (nodeDefinition.topics) {
		newNode.topics = nodeDefinition.topics;
	}
	if (nodeDefinition.pdfInsightId) {
		newNode.pdfInsightId = nodeDefinition.pdfInsightId;
	}
	if (nodeDefinition.pdfAnalysisId) {
		newNode.pdfAnalysisId = nodeDefinition.pdfAnalysisId;
	}
	if (nodeDefinition.pdfFileName) {
		newNode.pdfFileName = nodeDefinition.pdfFileName;
	}
	if (nodeDefinition.pdfProvenance) {
		newNode.pdfProvenance = nodeDefinition.pdfProvenance;
	}
	if (nodeDefinition.style) {
		newNode.style = nodeDefinition.style;
	}
	if (nodeDefinition.synthesiseRecipe) {
		newNode.synthesiseRecipe = nodeDefinition.synthesiseRecipe;
	}
	if (nodeDefinition.positioningOutput) {
		newNode.positioningOutput = nodeDefinition.positioningOutput;
		if (!hasImageSource) newNode.style = 'rect';
	}
	return newNode;
};
